export enum FieldType {
  Text = 1,
  Number = 2,
  BLOB = 3,
  Date = 4,
  KeywordLookup = 5,
  HTMLContent = 6,
  Boolean = 7,
  LongText = 8,
  Password = 9,
  RichText = 10,
  User = 11,
  Contact = 12,
}
